//import { RedemptionAction } from "./redemption-action";

export class RedemptionCode {
    public id: number;
    // private _code: string;
    // public get code(): string {
    //     return this._code;
    // }
    // public set code(val: string) {
    //     if (val.length > 36) {
    //         throw new Error('Redemption code max length is 36.');
    //     }
    //     this._code = val;
    // }
    public code: string;
    public dateRedeemedUtc: Date;

    private _actionParam: string;
    public get actionParam(): string {
      return this._actionParam;
    }
    public set actionParam(val: string) {
      if (val.length > 255) {
        throw new Error('Param length cannot be greater than 255'); // because the db says so
      }
      this._actionParam = val;
    }

    constructor(obj?: any) {
        this.id = obj && obj.Id || 0;
        this.code = obj && obj.Code || '';
        this.dateRedeemedUtc = obj && obj.DateRedeemedUtc || null;
        this.actionParam = obj && obj.ActionParameter || '';
    }
}
